import { Game, GameStore } from "../interfaces/game.interface";

class GGameStore {
  data: GameStore = {
    games: [],
  };

  setGames = (action: { payload: { games: Game[] } }) => {
    this.data.games = action.payload.games;
  };

  updateGame = (action: { payload: { game: Game } }) => {
    const index = this.data.games.findIndex(
      (g) => g.id === action.payload.game.id
    );
    if (index !== -1) {
      this.data.games[index] = action.payload.game;
      this.data.games = [...this.data.games];
    } else {
      // Game not found, do nothing
    }
  };
}

export const gameStore = new GGameStore();
